import type { Plugin } from "vue";

import PrimeVue from "primevue/config";
import AutoComplete from "primevue/autocomplete";
import Panel from "primevue/panel";
import Dropdown from "primevue/dropdown";
import Badge from "primevue/badge";
import Button from "primevue/button";
import SelectButton from "primevue/selectbutton";
import RadioButton from "primevue/radiobutton";
import Card from "primevue/card";
import Checkbox from "primevue/checkbox";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import DataTable from "primevue/datatable";
import Dialog from "primevue/dialog";
import Divider from "primevue/divider";
import InputMask from "primevue/inputmask";
import InputNumber from "primevue/inputnumber";
import InputSwitch from "primevue/inputswitch";
import InputText from "primevue/inputtext";
import Calendar from "primevue/calendar";
import Slider from "primevue/slider";
import FileUpload from "primevue/fileupload";
import Menubar from "primevue/menubar";
import Menu from "primevue/menu";
import OverlayPanel from "primevue/overlaypanel";
import ProgressSpinner from "primevue/progressspinner";
import ProgressBar from "primevue/progressbar";
import Sidebar from "primevue/sidebar";
import TabMenu from "primevue/tabmenu";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Tag from "primevue/tag";
import Toolbar from "primevue/toolbar";
import Tooltip from "primevue/tooltip";
import Toast from "primevue/toast";
import Chip from "primevue/chip";
import ToastService from "primevue/toastservice";
import BadgeDirective from "primevue/badgedirective";
import ConfirmationService from "primevue/confirmationservice";
import MultiSelect from "primevue/multiselect";
import Skeleton from "primevue/skeleton";

export const registerPrimevue: Plugin = {
  install(app) {
    app
      .use(PrimeVue)
      .use(ToastService)

      // add components to be installed globally
      .component("MultiSelect", MultiSelect)
      .component("AutoComplete", AutoComplete)
      .component("Badge", Badge)
      .component("Button", Button)
      .component("SelectButton", SelectButton)
      .component("RadioButton", RadioButton)
      .component("Panel", Panel)
      .component("Dropdown", Dropdown)
      .component("Card", Card)
      .component("Checkbox", Checkbox)
      .component("Column", Column)
      .component("ColumnGroup", ColumnGroup)
      .component("Dialog", Dialog)
      .component("Divider", Divider)
      .component("DataTable", DataTable)
      .component("FileUpload", FileUpload)
      .component("InputMask", InputMask)
      .component("InputNumber", InputNumber)
      .component("InputSwitch", InputSwitch)
      .component("InputText", InputText)
      .component("Calendar", Calendar)
      .component("Slider", Slider)
      .component("Menubar", Menubar)
      .component("Menu", Menu)
      .component("OverlayPanel", OverlayPanel)
      .component("ProgressSpinner", ProgressSpinner)
      .component("ProgressBar", ProgressBar)
      .component("Sidebar", Sidebar)
      .component("Toolbar", Toolbar)
      .component("TabView", TabView)
      .component("TabPanel", TabPanel)
      .component("Tag", Tag)
      .component("TabMenu", TabMenu)
      .component("Toast", Toast)
      .component("Chip", Chip)
      .component("Skeleton", Skeleton)
      .directive("tooltip", Tooltip)
      .directive("badge", BadgeDirective)
      .use(ConfirmationService);
  }
};
